<template>
  <div v-if="this.users" class="padding-zero">
    <table-header
      :title="'Użytkownicy, którzy próbowali się zalogować'"
      :withPagination="true"
      :dispatchAction="'getAllProfilesWhoTriedToLogIn'"
      :onPage="this.users.on_page"
      :pageNumber="this.users.page_number"
      :total="this.users.total_value"
      :refreshAction="true"
      :tableName="'usersWhoTriedToLogIn'"
    ></table-header>

    <table class="table  table-striped table-sm table-responsive">
      <thead>
        <tr style="width: 100%">
          <th scope="col">ID użytkownika</th>
          <th scope="col">Utworzono</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Telefon</th>
          <th scope="col">Data urodzenia</th>
          <th scope="col">Pesel</th>
          <th scope="col">Adresy użytkownika</th>
          <th scope="col">Numer konta</th>
          <th scope="col">Weryfikacja numeru konta</th>
          <th scope="col">Status</th>
          <th scope="col">Dystans</th>
          <th scope="col">Zdjęcie</th>
          <th scope="col">Status pracownika</th>
          <th scope="col">Usługi</th>
          <th scope="col">Płatności</th>
          <th scope="col">Wiadomość</th>
          <th scope="col">Szczegóły</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="data in this.users.user_profile_service"
          :key="data.user_profile.user.id"
        >
          <td>{{ data.user_profile.user.id }}</td>
          <td>{{ data.user_profile.user.creation_date }}</td>

          <td>{{ data.user_profile.profile.first_name }}</td>
          <td>{{ data.user_profile.profile.last_name }}</td>
          <td>{{ data.user_profile.user.phone }}</td>
          <td>
            {{
              data.user_profile.profile.birthdate
                ? formattedDateWithoutTime(data.user_profile.profile.birthdate)
                : "Brak"
            }}
          </td>
          <td>
            {{
              data.user_profile.profile.pesel
                ? data.user_profile.profile.pesel
                : "Brak"
            }}
          </td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              :data-target="`#address${data.id}`"
            >
              Pokaż
            </button>
          </td>
          <td>
            {{
              data.user_profile.profile.account_number
                ? data.user_profile.profile.account_number
                : "Brak"
            }}
          </td>
          <td
            v-if="
              !data.user_profile.profile.payment_verification_status ||
                data.user_profile.profile.payment_verification_status ===
                  'NOT_INITIALIZED'
            "
          >
            Nie rozpoczęto płatności weryfikacyjnej
          </td>
          <td
            v-if="
              data.user_profile.profile.payment_verification_status ===
                'ACCEPTED'
            "
          >
            Płatność weryfikacyjna zakończona pomyślnie
          </td>
          <td
            v-if="
              data.user_profile.profile.payment_verification_status ===
                'REJECTED'
            "
          >
            Płatność weryfikacyjna zakończona niepowodzeniem
          </td>
          <td
            v-if="
              data.user_profile.profile.payment_verification_status ===
                'CREATED'
            "
          >
            Płatność weryfikacyjna rozpoczęta, lecz niedokończona
          </td>

          <td>{{ data.user_profile.profile.profile_status }}</td>
          <td>{{ data.user_profile.profile.distance }}</td>
          <td>
            <a
              target="_blank"
              :href="
                getUrl() +
                  '/api/profile/photo/' +
                  data.user_profile.profile.file_path
              "
            >
              <img
                class="img-avatar"
                :src="
                  getUrl() +
                    '/api/profile/photo/' +
                    data.user_profile.profile.file_path
                "
              />
            </a>
          </td>

          <!-- :src="requestPhoto(fileId)" -->
          <td>{{ data.user_profile.profile.employee_status }}</td>

          <td>
            <button
              v-if="data.user_services && data.user_services.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              :data-target="`#userServices${data.id}`"
              v-on:click="setCurrentUserServices(data.user_services)"
            >
              Usługi
            </button>
            <span v-else>Brak usług</span>
          </td>
          <td>
            <router-link
              :to="{
                name: 'PaymentsList',
                query: { search: data.phone },
              }"
            >
              <button type="button" class="btn btn-outline-dark mr-3">
                Płatności
              </button>
            </router-link>
          </td>

          <td>
            <router-link :to="{ path: '/chat/' + data.id }">
              <button type="button" class="btn btn-outline-dark mr-3">
                Napisz
              </button>
            </router-link>
          </td>
          <td>
            <router-link :to="{ path: 'users/id/' + data.id }">
              <button
                type="button"
                class="btn btn-outline-dark mr-3"
                @click="getUser(data.id)"
              >
                Przejdź
              </button>
            </router-link>
          </td>

          <div
            class="modal fade"
            :id="`userServices${data.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl modal-xl" role="dialog">
              <div class="modal-content services-modal">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Usługi użytkownika
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">ID</th>
                        <th scope="col">Cena</th>
                        <th scope="col">ID usługi</th>
                        <th scope="col">Nazwa</th>
                        <th scope="col">Opis</th>
                        <th scope="col">Pierwszy próg</th>
                        <th scope="col">Drugi próg</th>
                        <th scope="col">Typ</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="item in currentUserServices"
                        v-bind:key="item.id"
                      >
                        <td>{{ item.id }}</td>
                        <td>{{ item.price }}</td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.display_name }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.first_threshold }}</td>
                        <td>{{ item.second_threshold }}</td>
                        <td>{{ item.type }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Adresy użytkownika -->
          <div
            class="modal fade"
            :id="`address${data.id}`"
            tabindex="-1"
            role="dialog"
            aria-labelledby="address"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="address">
                    Adresy użytkownika
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="changes = null"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <h4>Adres do faktury</h4>
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">Kod pocztowy</th>
                        <th scope="col">Miasto</th>
                        <th scope="col">Ulica</th>
                        <th scope="col">Numer budynku</th>
                        <th scope="col">Numer mieszkania</th>
                        <th scope="col">Piętro</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          {{
                            data.postcode_invoice
                              ? data.postcode_invoice
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.city_invoice ? data.city_invoice : "Brak" }}
                        </td>
                        <td>
                          {{
                            data.street_invoice ? data.street_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.number1_invoice ? data.number1_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.number2_invoice ? data.number2_invoice : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.floor_invoice ? data.floor_invoice : "Brak" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <h4>Adres świadczenia usług</h4>
                  <table class="table modal-table">
                    <thead>
                      <tr class="tr-table">
                        <th scope="col">Kod pocztowy</th>
                        <th scope="col">Miasto</th>
                        <th scope="col">Ulica</th>
                        <th scope="col">Numer budynku</th>
                        <th scope="col">Numer mieszkania</th>
                        <th scope="col">Piętro</th>
                        <th scope="col">Latitude</th>
                        <th scope="col">Longitude</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          {{
                            data.employee_postcode
                              ? data.employee_postcode
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{ data.employee_city ? data.employee_city : "Brak" }}
                        </td>
                        <td>
                          {{
                            data.employee_street ? data.employee_street : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_number1
                              ? data.employee_number1
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_number2
                              ? data.employee_number2
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_floor ? data.employee_floor : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_latitude
                              ? data.employee_latitude
                              : "Brak"
                          }}
                        </td>
                        <td>
                          {{
                            data.employee_longitude
                              ? data.employee_longitude
                              : "Brak"
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <span v-if="data.distance && data.postcode">
                    Promień świadczenia usług:
                    {{ data.distance }}km
                  </span>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                    @click="changes = null"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "../axios";
import { URL } from "../axios";
import shared from "../shared";
import TableHeader from "../components/TableHeader.vue";
/* import SortingPanel from '../components/SortingPanel.vue'; */
export default {
  name: "UsersWhoTriedToLogIn",
  components: {
    TableHeader,
  },

  computed: {
    users() {
      return this.$store.getters.getUsersWhoTriedToLogIn;
    },
    userServices() {
      return this.$store.getters.getUserServices;
    },
  },
  created() {
    this.$store.dispatch("getAllProfilesWhoTriedToLogIn", {
      on_page: 20,
      page_number: 1,
    });
    this.$store.dispatch("getUserServices");
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
  },
  methods: {
    getUser(id) {
      this.$store.dispatch("fetchUserByPhoneOrUserId", {
        param: id,
      });
    },
    getUrl() {
      return URL;
    },
    requestPhoto(id) {
      let url = "api/profile/photo/" + id;
      axios.get(url).then((response) => {
        const img = Buffer.from(response.data, "binary").toString("base64");
        return "data:image/png;base64," + img;
      });
    },

    setCurrentUserServices(services) {
      this.currentUserServices = services;
    },
    setCurrentUsers(data) {
      this.firstName = data.first_name;
      this.lastName = data.last_name;
      this.userId = data.id;
    },
  },

  data() {
    return {
      currentUserServices: [],
      firstName: "",
      lastName: "",
      selectedService: "",
      userId: "",
      searchParam: "",
      filteringOptions: [
        {
          name: "ALL",
          displayName: "Wszystkie",
          icon: "",
        },
        {
          name: "NONE",
          displayName: "Bez statusu",
        },
        {
          name: "ACCEPTED",
          displayName: "Zweryfikowany",
        },
        {
          name: "REJECTED",
          displayName: "Niezaakceptowany",
        },
        {
          name: "WAITING",
          displayName: "Oczekujący",
        },
        {
          name: "WAITING_WITHOUT_PAYMENT",
          displayName: "Bez rozpoczętej płatności",
        },
        {
          name: "WAITING_WITH_STARTED_PAYMENT",
          displayName: "Z rozpoczętą, niedokończoną płatnością",
        },
        {
          name: "deleted",
          displayName: "Użytkownicy usunięci",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
